import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ProgressTabs from '../components/ProgressTabs';
import SweatTextTitle from '../steps/SweatTextTitle';
import RemindersInfo from './RemindersInfo';
import '../BasicReminder.css';
import { getBackendURL } from '../utils';
import { useAuth } from '../auth';

const StepInviteClient = () => {
  const [email, setEmail] = useState('');
  const [client, setClient] = useState(null);
  const navigate = useNavigate();
  const { user, fetchUserInfo } = useAuth();
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  React.useEffect(() => {
    fetchUserInfo(); // Refresh user info to get the latest client data
  }, []);

  React.useEffect(() => {
    setClient(user?.trainer_info?.clients?.[0] || null);
  }, [user]);

  const sendInvite = async () => {
    if (!client || !email) return;
    setSending(true);
    setSent(false);
    setError('');
    try {
      await fetch(getBackendURL() + `/client/${client.id}`,
        {
          method: 'PUT',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${window.localStorage.getItem('ptc_access_token') || ''}`
          },
          body: JSON.stringify({ pre_user_email: email })
        }
      );
      await fetch(getBackendURL() + '/api/invite-client', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.localStorage.getItem('ptc_access_token') || ''}`
        },
        body: JSON.stringify({ email, name: client.pre_user_name })
      });
      setSent(true);
    } catch (err) {
      setError('Failed to send invite.');
    } finally {
      setSending(false);
    }
  };

  // If no user redirect to homepage.
  if (!user) {
    return (
      <div className="reminder-container fogged-card">
        Sorry, you must be logged in to access this page.
      </div>
    );
  } 
  return (
    <div className="reminder-container fogged-card">
      <SweatTextTitle />
      <RemindersInfo />
      <ProgressTabs currentStep={6} />
      <h2 className="step-title">Step 7: Invite {client ? client.pre_user_name : 'Your Client'} </h2>
      <p>To wrap it up, we want to invite {client ? client.pre_user_name : 'your client'} to receive the reminders from us, via email.</p>
      <input
        type="email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        placeholder="Client's email address"
        style={{ padding: '0.75rem 1rem', fontSize: '1rem', width: '100%', maxWidth: '400px', marginBottom: '1.5rem', borderRadius: '6px', border: '1px solid #ccc' }}
      />
      <button
        onClick={sendInvite}
        style={{ padding: '0.75rem 1.5rem', 
          background: (!email || sending || !client) ? '#ccc' : '#28a745', 
          color: (!email || sending || !client) ? '#222' : 'white', 
          border: 'none', 
          cursor: (!email || sending || !client) ? 'not-allowed' : 'pointer',
          fontSize: '1rem', marginBottom: '1.5rem', borderRadius: '6px', border: 'none', backgroundColor: '#28a745', color: 'white', cursor: 'pointer' }}
        disabled={!email || sending || !client}
      >
        {sending ? 'Sending...' : 'Send Invite Email Now!'}
      </button>
      {sent && <p style={{ color: 'green', fontWeight: 'bold' }}>Invite sent to {email}!</p>}
      {error && <p style={{ color: 'red', fontWeight: 'bold' }}>{error}</p>}
      <p>
        After that, feel free to check out the dashboard, add other clients, and enjoy!
      </p>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '2rem' }}>
        <button
          className="ptc-secondary-button"
          style={{ padding: '1rem 2rem', fontSize: '1rem', background: '#ccc', color: '#222', border: 'none' }}
          onClick={() => navigate('/tools/reminders/stepnextappointment')}
        >
          Previous Step
        </button>
        <button
          className="ptc-button"
          style={{ padding: '1rem 2rem', 
            background: sent ? '#6610f2' : '#ccc', 
            color: sent ? 'white' : '#222', 
            border: 'none', 
            cursor: sent ? 'pointer' : 'not-allowed',
            fontSize: '1rem' }}
          onClick={() => navigate('/tools/reminders/dashboard')}
          disabled={!sent}
        >
          Continue to Dashboard!
        </button>
      </div>
    </div>
  );
};

export default StepInviteClient;
